import { useClock } from "@/hooks/useClock";
import { Apple, Wifi, Battery, Search, Volume2, VolumeX } from "lucide-react";

export default function MenuBar({ activeApp, muted, onToggleMute }) {
  const now = useClock();
  const dateStr = now.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  const timeStr = now.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return (
    <div
      data-testid="menu-bar"
      className="fixed top-0 left-0 right-0 h-7 z-[80] flex items-center px-3 gap-4 text-[13px] text-white/95 bg-black/25 border-b border-white/10 select-none"
      style={{ backdropFilter: "blur(18px)" }}
    >
      <Apple size={14} className="fill-white" />
      <span className="font-bold">{activeApp || "Finder"}</span>
      <span className="hidden sm:inline opacity-80">File</span>
      <span className="hidden sm:inline opacity-80">Edit</span>
      <span className="hidden md:inline opacity-80">View</span>
      <span className="hidden md:inline opacity-80">Window</span>
      <div className="flex-1" />
      {onToggleMute && (
        <button data-testid="mute-toggle" onClick={onToggleMute} className="p-0.5 rounded hover:bg-white/10 transition" aria-label="Toggle music">
          {muted ? <VolumeX size={14} className="opacity-80" /> : <Volume2 size={14} className="opacity-80" />}
        </button>
      )}
      <span className="opacity-90 font-medium hidden xs:inline">corysuggs</span>
      <Battery size={16} className="opacity-80" />
      <Wifi size={15} className="opacity-80" />
      <Search size={13} className="opacity-80" />
      <span className="opacity-95">{dateStr}&nbsp;&nbsp;{timeStr}</span>
    </div>
  );
}
